<template>
  <div grid-list-xs class="d-flex justify-center align-center my-10">
    <v-card class="card-radius card-shadow my-16" :class="cardWidth == 'another-card-width' ? 'another-card-width' : 'card-width'" elevation="0">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium px-10"
        >Syarat Pendaftaran</v-card-title
      >
      <v-container class="py-8">
        <div class="content px-5">
          <p class="font-weight-bold">Persyaratan pendaftaran calon peserta didik baru SMK Raden Umar Said Kudus:</p>
            <ul>
              <li>Keterangan tempat tinggal atau domisili dibuktikan dengan Kartu Keluarga (KK). Pendaftar dalam kota wajib melampirkan KK.</li>
              <li>Usia pada saat mendaftar tidak lebih dari 19 tahun</li>
              <li>Tinggi badan siswa laki-laki minimal 150cm (bagi pendaftar program keahlian DKV Konsentrasi Teknik Grafika)</li>
              <li>Tinggi badan siswi perempuan minimal 145cm (bagi pendaftar program keahlian DKV Konsentrasi Teknik Grafika)</li>
              <li>Siswa putra tidak bertindik</li>
              <li>Tidak bertato baik putra/putri</li>
              <!-- <li>Tidak memiliki cacat tubuh/fisik yang dapat mengganggu proses pembelajaran</li> -->
            </ul>
        </div>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SyaratPendaftaran",
  props: ["cardWidth"]
};
</script>


<style scoped>
.dark-blue {
  background-color: #24305e !important;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.card-width {
  width: 60%;
}

.another-card-width {
  width: 85%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.berkas-section {
  min-height: 80vh;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 90%;
  }
}
</style>